import { createI18n } from 'vue-i18n'
const messages = {
  en: {
    header: {
      greeting: "Hi,",
      intro: "I'm",
      name: "Miłosz",
      subtitle: "Creating solutions that make everyday life easier",
      viewWork: "View my projects",
      getInTouch: "Get in touch",
      scrollDown: "Scroll down"
    },
    info: {
      experience: {
        title: "Experience",
        years: "Over 4 years in web technologies",
        description: "Frontend developer with backend experience, specializing in e-commerce platforms, custom applications, and AI solutions."
      },
      skills: {
        title: "Skills",
        list: "Full-stack developer",
        description: "Proficient in JavaScript frameworks like Vue.js and React, as well as backend technologies like Flask. Skilled in creating intuitive user interfaces and advanced AI-based systems."
      },
      education: {
        title: "Education",
        degree: "Computer Science Engineer",
        description: "Currently completing an engineering thesis on intelligent library systems using AI, focusing on user support and data processing."
      },
      interests: {
        title: "Interests",
        list: "AI, Frontend",
        description: "Passionate about creating AI-driven solutions that make everyday life easier and designing intuitive interfaces. Exploring AI possibilities to build technologies that assist users in their daily tasks and offer user-friendly experiences."
      },
      knowledge: {
        title: "Technologies"
      }
    },
    projects: {
      title: "My Projects",
      techStack: "Technologies",
      viewProject: "View Project",
      projectsList: [
        {
          title: "AI-Powered Customer Support Chatbot",
          description: "A customer support chatbot built with Vue.js and Flask, utilizing RAG methodology and semantic search to provide quick and accurate responses to user inquiries.",
          status: "In Progress"
        },
        {
          title: "Metadata Generation for Medical Research",
          description: "A solution for generating metadata for search engines in the medical industry, leveraging artificial intelligence and fine-tuning techniques.",
          status: "Completed"
        },
        {
          title: "B2B E-commerce Platform",
          description: "A B2B e-commerce platform built with Shopware 6 and Vue.js, serving over 2000 users across various sales channels. It provides omnichannel management and custom integrations tailored to industry-specific requirements.",
          status: "Completed"
        },
        {
          title: "Website for Accounting Firm",
          description: "A professional website for an accounting firm, developed with React.js and MUI. The site features a modern, responsive design and an interactive calculator for quick cost estimates by users.",
          status: "Completed"
        },
        {
          title: "Hotspot Management Panel",
          description: "An administrative panel for managing Wi-Fi networks and IoT devices, built in Next.js and TypeScript. The platform enables efficient router management and monitoring across multiple locations.",
          status: "Completed"
        },
        {
          title: "E-commerce Store",
          description: "An e-commerce platform based on WordPress, WooCommerce, and Divi Builder. The site is optimized for both mobile and desktop, providing a seamless online shopping experience.",
          status: "Completed"
        },
        {
          title: "Flatscanner – Apartment Search Platform",
          description: "A startup platform supporting apartment rental searches, based on maps and vector graphics, allowing for attractive property presentation within buildings.",
          status: "Completed"
        }
      ]
    },
    experiences: {
      title: "Experience",
      experiences: [
        { 
          role: "Junior AI Engineer", 
          company: "Sunzinet", 
          duration: "2024 - present",
          techStack: ["Python", "ChromaDB", "OpenAI"]
        },
        { 
          role: "Frontend Developer", 
          company: "Sunzinet", 
          duration: "2023 - 2024",
          techStack: ["Vue.js", "JavaScript", "Shopware", "Gradio"]
        },
        { 
          role: "Web Developer", 
          company: "Freelance", 
          duration: "2022 - 2023",
          techStack: ["React", "Next.js", "Vercel", "Figma"]
        },
        { 
          role: "Junior Frontend Developer", 
          company: "Modelit", 
          duration: "2021 - 2022",
          techStack: ["Nuxt.js", "React", "HTML", "CSS"]
        }
      ]
    },
    contact: {
      title: "Let's Connect",
      description: "Feel free to reach out for collaborations or just a friendly hello",
    }
  },
  pl: {
    header: {
      greeting: "Cześć,",
      intro: "Jestem",
      name: "Miłosz",
      subtitle: "Tworze rozwiązania, które ułatwiają codzienne życie",
      viewWork: "Zobacz moje projekty",
      getInTouch: "Skontaktuj się",
      scrollDown: "Przewiń w dół"
    },
    info: {
      experience: {
        title: "Doświadczenie",
        years: "Ponad 4 lata w technologiach webowych",
        description: "Frontend developer z doświadczeniem backendowym, specjalizujący się w platformach e-commerce, tworzeniu aplikacji niestandardowych oraz rozwiązań AI."
      },
      skills: {
        title: "Umiejętności",
        list: "Full-stack developer",
        description: "Biegła znajomość frameworków JavaScript, takich jak Vue.js i React, a także technologii backendowych, jak Flask. Potrafię tworzyć intuicyjne interfejsy użytkownika oraz zaawansowane systemy oparte na sztucznej inteligencji."
      },
      education: {
        title: "Edukacja",
        degree: "Inżynier Informatyki",
        description: "Kończę pracę inżynierską na temat inteligentnych systemów bibliotecznych z wykorzystaniem AI, z naciskiem na wsparcie użytkownika oraz przetwarzanie danych."
      },
      interests: {
        title: "Zainteresowania",
        list: "AI, Frontend",
        description: "Pasjonuję się tworzeniem rozwiązań opartych na AI, które ułatwiają codzienne życie, oraz projektowaniem intuicyjnych interfejsów. Eksploruję możliwości AI, aby tworzyć technologie wspierające użytkowników w ich codziennych zadaniach i oferujące przyjazne doświadczenia."
      },
      knowledge: {
        title: "Technologie",
      }
    },
    projects: {
      title: "Moje Projekty",
      techStack: "Technologie",
      viewProject: "Zobacz Projekt",
      projectsList: [
        {
          title: "Chatbot wspierający obsługę klienta oparty na AI",
          description: "Chatbot wspierający obsługę klienta, oparty na technologiach Vue.js i Flask, wykorzystujący metodologię RAG oraz wyszukiwanie semantyczne, aby zapewnić szybkie i trafne odpowiedzi na zapytania użytkowników.",
          status: "W trakcie"
        },
        {
          title: "Generowanie Metadanych dla Badań Medycznych",
          description: "Rozwiązanie umożliwiające generowanie metadanych dla wyszukiwarek w branży medycznej, z wykorzystaniem sztucznej inteligencji i technik fine-tuningu",
          status: "Gotowe"
        },
        {
          title: "Platforma e-commerce B2B",
          description: "Platforma e-commerce B2B, stworzona z wykorzystaniem Shopware 6 i Vue.js, obsługująca ponad 2000 użytkowników w różnych kanałach sprzedaży. Zapewnia wielokanałowe zarządzanie oraz niestandardowe integracje, dostosowane do specyficznych wymagań branżowych.",
          status: "Gotowe"
        },
        {
          title: "Strona internetowa dla firmy księgowej",
          description: "Profesjonalna strona internetowa dla firmy księgowej, opracowana z użyciem React.js i MUI. Witryna cechuje się nowoczesnym, responsywnym designem oraz interaktywnym kalkulatorem do szybkiego oszacowania kosztów księgowości przez użytkowników.",
          status: "Gotowe"
        },
        {
          title: "Panel zarządzania hotspotami",
          description: "Panel administracyjny do zarządzania sieciami Wi-Fi i urządzeniami IoT, zbudowany w Next.js i TypeScript. Platforma pozwala na efektywne zarządzanie routerami oraz monitorowanie ich stanu w wielu lokalizacjach.",
          status: "Gotowe"
        },
        {
          title: "Sklep internetowy",
          description: "Platforma e-commerce, oparta na WordPressie, WooCommerce i Divi Builderze. Witryna została zoptymalizowana pod kątem urządzeń mobilnych i stacjonarnych, zapewniając wygodne zakupy online.",
          status: "Gotowe"
        },
        {
          title: "Flatscanner – Platforma do wyszukiwania mieszkań",
          description: "Startup platformy wspierającej wyszukiwanie mieszkań na wynajem, oparta na mapach i grafice wektorowej, umożliwiająca atrakcyjną prezentację nieruchomości w budynkach.",
          status: "Gotowe"
        }
      ]
    },
    experiences: {
      title: "Doświadczenie",
      experiences: [
        { 
          role: "Młodszy Inżynier AI", 
          company: "Sunzinet", 
          duration: "2024 - obecnie",
          techStack: ["Python", "ChromaDB", "OpenAI"]
        },
        { 
          role: "Frontend Developer", 
          company: "Sunzinet", 
          duration: "2023 - 2024",
          techStack: ["Vue.js", "JavaScript", "Shopware", "Gradio"]
        },
        { 
          role: "Web Developer", 
          company: "Wolny Strzelec", 
          duration: "2022 - 2023",
          techStack: ["React", "Next.js", "Vercel", "Figma"]
        },
        { 
          role: "Młodszy Frontend Developer", 
          company: "Modelit", 
          duration: "2021 - 2022",
          techStack: ["Nuxt.js", "React", "HTML", "CSS"]
        }
      ]
    },
    contact: {
      title: "Kontakt",
      description: "Zapraszam do kontaktu w sprawie współpracy.",
    }
  }
}

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
})

export { i18n }
